import { useLocation } from "react-router-dom";

import { useVerifyApplicationTokenQuery } from "@/redux/service";
import InviteRegister from "./components/InviteRegister";
import SingleStepRegister from "./components/SingleStepRegister";
import RegisterInvalidLink from "./components/RegisterInvalidLink";
import {
  getRegistrationFlow,
  RegistrationFlow,
} from "./utils/getRegistrationFlow";

const Register = () => {
  const { search } = useLocation();
  const flow = getRegistrationFlow(search);

  switch (flow) {
    case RegistrationFlow.Application:
      return (
        <SingleStepRegister useVerifyToken={useVerifyApplicationTokenQuery} />
      );
    case RegistrationFlow.Invite:
      return <InviteRegister />;
    default:
      return <RegisterInvalidLink />;
  }
};

export default Register;
